import { render, staticRenderFns } from "./ResultRowDetail.vue?vue&type=template&id=1d6cd95f&scoped=true&"
import script from "./ResultRowDetail.vue?vue&type=script&lang=js&"
export * from "./ResultRowDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultRowDetail.vue?vue&type=style&index=0&id=1d6cd95f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cd95f",
  null
  
)

export default component.exports